import logErrors from '@nykaa/logger/logErrors';
import { ApiHelper } from 'shared/api';
import { contentTypes } from 'shared/constants/requestHeaders';
import { NotifyMeParams } from './types';


const ERROR_IN_NOTIFY_ME = 'Error in Notify Me';
export const notifyMe = async (params: NotifyMeParams) => {
  const url = '/ajaxaddcart/index/outofStockSubscription/';
  const formData = new FormData();
  const validParams = (params && (params.email) && (params.productId));
  if (validParams) {
    formData.append('isAjax', '1');
    formData.append('subscription_email', params.email);
    formData.append('variantName', params.variantName);
    formData.append('offerPrice', `${params.offerPrice}`);
    formData.append('product', `${params.productId}`);

    try {
      const { data: { error, message } } = await ApiHelper(`${url}`, 'post', formData, { 'Content-Type':  contentTypes.URL_ENCODED });
      if (error) {
        return Promise.reject({
          message,
        });
      }

      return true;
    } catch (e) {
      logErrors(e, `${ERROR_IN_NOTIFY_ME} :url=${url}`);
        throw e;
    }
  }
};
